(function () {
  'use strict';

  /** 方向未定时移动小于此值，不判定，避免误触 */
  const TOUCH_SLOP_PX = 10;
  /** |dx| 需大于 |dy| * 此系数才视为横向，避免斜滑时抢页面滚动 */
  const TOUCH_HORIZONTAL_RATIO = 1.12;

  function initMtSwiper() {
    const sections = document.querySelectorAll('.mt-swiper-section');
    if (!sections.length) return;

    sections.forEach(function (section) {
      new MtSwiper(section);
    });
  }

  class MtSwiper {
    constructor(section) {
      this.section = section;
      this.container = section.querySelector('.mt-swiper-container');
      this.wrapper = section.querySelector('.mt-swiper-wrapper');
      this.track = this.wrapper; // wrapper 就是 track
      this.productItems = Array.from(section.querySelectorAll('.mt-swiper-product-item'));
      // 建立 block 序号（data-block-index）到产品卡 DOM 的映射，
      // 避免因为前面某些 block 没有 product 导致下标错位。
      this.productMap = new Map();
      this.productItems.forEach((item) => {
        const idxAttr = item.getAttribute('data-block-index');
        const realIdx = parseInt(idxAttr, 10);
        if (!Number.isNaN(realIdx)) {
          this.productMap.set(realIdx, item);
        }
      });
      this.prevBtn = section.querySelector('.mt-swiper-prev');
      this.nextBtn = section.querySelector('.mt-swiper-next');
      
      if (!this.wrapper || !this.container) return;

      // 获取真实的 slides（不包括克隆）
      this.slides = Array.from(this.wrapper.querySelectorAll('.mt-swiper-slide:not(.is-clone)'));
      if (!this.slides.length) return;

      this.visible = 1; // 每次显示1个（居中）
      this.index = this.slides.length; // 初始索引：前面会有克隆
      this.realCount = this.slides.length;
      this.isTransitioning = false;
      this.autoplayDelay = parseInt(this.wrapper.getAttribute('data-autoplay')) || 0;
      this.autoplayTimer = null;
      this.transitionUnlockTimer = null;
      this.isDragging = false;
      this.startX = 0;
      this.startY = 0;
      this.currentX = 0;
      this.offsetX = 0;
      this.initialTransform = 0;
      /** 触摸序列：touchstart 至 touchend */
      this.touchSession = false;
      /** null 未判定 | 'horizontal' 横向轮播 | 'vertical' 交给页面纵向滚动 */
      this.touchGesture = null;
      /** 标记是否需要延迟边界重置，避免点击切换后立即跳转 */
      this.skipNextBoundaryCheck = false;
      /** 记录用户手动暂停的视频，key 为 slide 的 fullIdx */
      this.manuallyPausedVideos = new Set();

      this.init();
    }

    init() {
      
      this.buildClones();
      this.setupEventListeners();
      this.setupVideos();
      
      // 等待 DOM 渲染完成后再设置位置
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const cIdx = this.index + this.centerOffset();
          this.translateTo(this.index, false);
          this.updateActiveSlide(cIdx);
          this.updateProductCard();
          this.playCenterVideo();
        });
      });
      
      this.startAutoplay();
    }

    buildClones() {
      // 清理旧克隆
      Array.from(this.wrapper.querySelectorAll('.is-clone')).forEach(function(n) { 
        n.remove(); 
      });
      
      this.slides = Array.from(this.wrapper.querySelectorAll('.mt-swiper-slide:not(.is-clone)'));
      
      if (this.slides.length === 0) return;
      
      // 为了无缝轮播，需要克隆足够多的slides
      // 至少克隆 realCount 个，确保左右都有足够的内容
      var count = Math.max(this.visible, Math.min(this.realCount, 3)); // 至少克隆3个，或者realCount（取较小值）
      this.cloneCount = count;
      
      for (var i = 0; i < count; i++) {
        var tailClone = this.slides[i].cloneNode(true);
        tailClone.classList.add('is-clone');
        this.wrapper.appendChild(tailClone);
        
        var headClone = this.slides[this.slides.length - 1 - i].cloneNode(true);
        headClone.classList.add('is-clone');
        this.wrapper.insertBefore(headClone, this.wrapper.firstChild);
      }
      
      // 更新索引：前面有 count 个克隆
      this.index = count;
    }

    getGap() {
      const cs = getComputedStyle(this.wrapper);
      const gap = cs.columnGap || cs.gap || '0px';
      return parseFloat(gap) || 0;
    }

    slideSize() {
      const firstSlide = this.wrapper.querySelector('.mt-swiper-slide');
      if (!firstSlide) {
        return 0;
      }
      const rect = firstSlide.getBoundingClientRect();
      // 如果宽度为0，尝试使用计算样式
      if (rect.width === 0) {
        const cs = getComputedStyle(firstSlide);
        const width = parseFloat(cs.width) || 281; // 默认值 281px
        return width;
      }
      return rect.width;
    }

    centerOffset() {
      return this.visible === 1 ? 0 : 1;
    }

    translateTo(i, withTransition) {
      console.log('[translateTo] index:', i, 'withTransition:', withTransition);
      
      if (withTransition === false) {
        this.wrapper.style.transition = 'none';
      } else {
        this.wrapper.style.transition = 'transform 400ms ease';
        this.isTransitioning = true;

        // 兜底：如果 transform 没发生变化，可能不会触发 transitionend，
        // 导致 isTransitioning 永远为 true，从而拖拽/滑动被锁死。
        if (this.transitionUnlockTimer) {
          clearTimeout(this.transitionUnlockTimer);
        }
        this.transitionUnlockTimer = setTimeout(() => {
          this.isTransitioning = false;
          this.transitionUnlockTimer = null;
        }, 500);
      }
      
      const w = this.slideSize();
      if (w === 0) {
        // 如果宽度为0，延迟执行
        requestAnimationFrame(() => {
          this.translateTo(i, withTransition);
        });
        return;
      }
      
      const gap = this.getGap();
      const step = w + gap;
      
      // 小屏（<=750px）时：按「一个完整 item 宽度 + 间距」的倍数来平移，
      // 保证左侧不露前一张，只在右侧露出下一张的一部分。
      const cIdx = i + this.centerOffset();
      let x;
      if (window.innerWidth <= 750) {
        x = -(i * step);
      } else {
        // 大屏保持原来的居中逻辑：以中心项 cIdx 的中心对齐视口中心
        const viewportCenter = (this.container && this.container.clientWidth ? this.container.clientWidth : window.innerWidth) / 2;
        const slideCenter = (cIdx * step) + (w / 2);
        x = -(slideCenter - viewportCenter);
      }
      
      // 避免子像素抖动：按像素取整
      const xInt = Math.round(x);
      this.wrapper.style.transform = 'translate3d(' + xInt + 'px, 0, 0)';
      
      // 更新 active 类
      this.updateActiveSlide(cIdx);
      
      // 验证位置
      requestAnimationFrame(() => {
        const centerSlide = this.wrapper.querySelectorAll('.mt-swiper-slide')[cIdx];
          if (centerSlide) {
            const rect = centerSlide.getBoundingClientRect();
            const containerRect = this.container.getBoundingClientRect();
            // 计算 slide 的中心相对于 container 的位置
            const actualCenter = rect.left + rect.width / 2 - containerRect.left;
            const expectedCenter = containerRect.width / 2;
      
          }
      });
    }

    indexToReal(i) {
      const cloneCount = Math.max(this.visible, Math.min(this.realCount, 3));
      const x = (i - cloneCount) % this.realCount;
      return (x + this.realCount) % this.realCount;
    }

    /**
     * 根据真实索引（block index）跳转到对应的 slide
     * @param {number} realIdx - 0 ~ realCount-1，对应 data-block-index
     */
    goToRealIndex(realIdx) {
      if (realIdx < 0 || realIdx >= this.realCount) return;

      const allSlides = Array.from(this.wrapper.querySelectorAll('.mt-swiper-slide'));
      if (!allSlides.length) return;

      // 克隆 slide 也会带同样的 data-block-index。
      // 如果直接 find()，往往会命中最前面的“头部克隆”，导致看起来总是跳回第一个。
      // 这里改为：找出所有匹配项，再选择离当前中心索引最近的那个，避免被克隆劫持。
      const matches = allSlides
        .map((slide, idx) => ({ slide, idx }))
        .filter(({ slide }) => String(slide.getAttribute('data-block-index')) === String(realIdx));
      if (!matches.length) return;

      const currentCenterIdx = this.index + this.centerOffset();
      let targetFullIdx = matches[0].idx;
      let bestDist = Math.abs(matches[0].idx - currentCenterIdx);
      for (let k = 1; k < matches.length; k++) {
        const dist = Math.abs(matches[k].idx - currentCenterIdx);
        if (dist < bestDist) {
          bestDist = dist;
          targetFullIdx = matches[k].idx;
        }
      }

      // 因为 translateTo 内部会用 index + centerOffset() 定位到真正居中的项
      const nextIndex = targetFullIdx - this.centerOffset();
      if (nextIndex === this.index) {
        // 已经在目标项上：避免触发一次“空过渡”把 isTransitioning 锁死
        this.updateProductCard();
        this.playCenterVideo();
        this.resetAutoplay();
        return;
      }
      this.index = nextIndex;
      this.translateTo(this.index, true);
      this.updateProductCard();
      this.playCenterVideo();
      this.resetAutoplay();
    }

    setupEventListeners() {
      // Transition end - 无缝重置
      this.wrapper.addEventListener('transitionend', () => {
        console.log('[transitionend] index:', this.index, 'skipNextBoundaryCheck:', this.skipNextBoundaryCheck);
        
        if (this.transitionUnlockTimer) {
          clearTimeout(this.transitionUnlockTimer);
          this.transitionUnlockTimer = null;
        }
        const cloneCount = this.cloneCount ?? Math.max(this.visible, Math.min(this.realCount, 3));
        
        console.log('[transitionend] cloneCount:', cloneCount, 'realCount:', this.realCount);
        
        // 边界重置：移动到克隆区域时，无缝跳转到对应的真实区域
        let needReset = false;
        let targetIndex = this.index;
        
        if (this.index >= this.realCount + cloneCount) {
          console.log('[transitionend] 需要边界重置：index >= realCount + cloneCount');
          needReset = true;
          const allSlides = Array.from(this.wrapper.querySelectorAll('.mt-swiper-slide'));
          const currentSlide = allSlides[this.index + this.centerOffset()];
          const currentBlockIdx = currentSlide ? currentSlide.getAttribute('data-block-index') : null;
          console.log('[transitionend] 当前克隆项的 block-index:', currentBlockIdx);
          
          const rangeStart = cloneCount;
          const rangeEnd = cloneCount + this.realCount - 1;
          const targetRealFullIdx = allSlides.findIndex((s, idx) => {
            const candidateIndex = idx - this.centerOffset();
            return s.getAttribute('data-block-index') === currentBlockIdx 
                   && candidateIndex >= rangeStart 
                   && candidateIndex <= rangeEnd;
          });
          
          if (targetRealFullIdx !== -1) {
            targetIndex = targetRealFullIdx - this.centerOffset();
          }
        } else if (this.index < cloneCount) {
          console.log('[transitionend] 需要边界重置：index < cloneCount (', cloneCount, ')');
          needReset = true;
          const allSlides = Array.from(this.wrapper.querySelectorAll('.mt-swiper-slide'));
          const currentSlide = allSlides[this.index + this.centerOffset()];
          const currentBlockIdx = currentSlide ? currentSlide.getAttribute('data-block-index') : null;
          console.log('[transitionend] 当前克隆项的 block-index:', currentBlockIdx);
          
          const rangeStart = cloneCount;
          const rangeEnd = cloneCount + this.realCount - 1;
          const targetRealFullIdx = allSlides.findIndex((s, idx) => {
            const candidateIndex = idx - this.centerOffset();
            return s.getAttribute('data-block-index') === currentBlockIdx 
                   && candidateIndex >= rangeStart 
                   && candidateIndex <= rangeEnd;
          });
          
          if (targetRealFullIdx !== -1) {
            targetIndex = targetRealFullIdx - this.centerOffset();
          }
        }
        
        // 如果需要重置，一次性完成所有操作，避免中间状态
        if (needReset && targetIndex !== this.index) {
          console.log('[transitionend] 执行无缝重置：', this.index, '->', targetIndex);
          const allSlides = Array.from(this.wrapper.querySelectorAll('.mt-swiper-slide'));
          
          // 1. 禁用所有过渡效果
          const prevWrapperTransition = this.wrapper.style.transition;
          const prevTransitions = allSlides.map(slide => slide.style.transition || '');
          this.wrapper.style.transition = 'none';
          allSlides.forEach(slide => {
            slide.style.transition = 'none';
          });
          
          // 2. 立即更新 index 并移动位置
          this.index = targetIndex;
          const cIdx = this.index + this.centerOffset();
          this.updateActiveSlide(cIdx);
          
          // 3. 计算并应用新的 transform
          const w = this.slideSize();
          const gap = this.getGap();
          const step = w + gap;
          let x;
          if (window.innerWidth <= 750) {
            x = -(this.index * step);
          } else {
            const viewportCenter = (this.container && this.container.clientWidth ? this.container.clientWidth : window.innerWidth) / 2;
            const slideCenter = (cIdx * step) + (w / 2);
            x = -(slideCenter - viewportCenter);
          }
          const xInt = Math.round(x);
          this.wrapper.style.transform = 'translate3d(' + xInt + 'px, 0, 0)';
          
          // 4. 强制回流，确保浏览器应用了无动画状态
          void this.wrapper.offsetHeight;
          
          // 5. 恢复过渡效果
          this.wrapper.style.transition = prevWrapperTransition;
          allSlides.forEach((slide, idx) => {
            slide.style.transition = prevTransitions[idx] || '';
          });
        }
        
        requestAnimationFrame(() => {
          this.isTransitioning = false;
        });
        
        this.updateProductCard();
        this.playCenterVideo();
      });

      // Navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          console.log('[mt-swiper2] prev button clicked, isTransitioning =', this.isTransitioning);
          this.prev();
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          console.log('[mt-swiper2] next button clicked, isTransitioning =', this.isTransitioning);
          this.next();
        });
      }

      // 点击图片 / 视频所在的 slide，切换到该项
      const allSlides = Array.from(this.wrapper.querySelectorAll('.mt-swiper-slide'));
      if (allSlides.length) {
        allSlides.forEach((slide, fullIdx) => {
          slide.addEventListener('click', (e) => {
        

            // 如果在真正拖拽（有明显位移）或过渡中，则不响应点击，避免误触
            const isRealDragging = this.isDragging && Math.abs(this.offsetX || 0) > 5;
            // 只在真正拖拽时屏蔽点击；处于过渡中也允许点击，立即跳到新目标
            if (isRealDragging) {
              return;
            }

            const centerIdx = this.index + this.centerOffset();
            console.log('[slide click] fullIdx:', fullIdx, 'centerIdx:', centerIdx, 'current index:', this.index);
            
            if (fullIdx === centerIdx) {
              // 已经是居中项，保持当前逻辑（视频自动播放在 playCenterVideo 中处理）
              console.log('[slide click] 已经是居中项，不做切换');
              return;
            }

            const cloneCount = this.cloneCount ?? Math.max(this.visible, Math.min(this.realCount, 3));
            const clickedBlockIdx = slide.getAttribute('data-block-index');
            
            // 计算被点击项相对于当前中心的偏移量（几步之差）
            const clickedIndex = fullIdx - this.centerOffset();
            const stepsToMove = clickedIndex - this.index;
            
            console.log('[slide click] clickedBlockIdx:', clickedBlockIdx, 'clickedIndex:', clickedIndex, 'stepsToMove:', stepsToMove);
            
            // 清除当前居中 slide 的手动暂停标记（因为要切换到新的 slide 了）
            this.manuallyPausedVideos.delete(centerIdx);
            
            // 找出真实范围内对应的 block-index 的 slide
            const rangeStart = cloneCount;
            const rangeEnd = cloneCount + this.realCount - 1;
            
            const targetRealIdx = allSlides.findIndex((s, idx) => {
              const candidateIndex = idx - this.centerOffset();
              return s.getAttribute('data-block-index') === clickedBlockIdx 
                     && candidateIndex >= rangeStart 
                     && candidateIndex <= rangeEnd;
            });
            
            if (targetRealIdx !== -1) {
              const targetIndex = targetRealIdx - this.centerOffset();
              console.log('[slide click] 找到真实项 fullIdx:', targetRealIdx, 'targetIndex:', targetIndex);
              
              // 根据移动方向，选择合适的路径
              // 如果点击的是左边（stepsToMove < 0），且目标在右侧，说明点击的是克隆
              // 此时应该向左移动到克隆位置，让 transitionend 无缝重置
              if (stepsToMove < 0) {
                // 向左移动：直接移动到被点击的位置（可能是克隆）
                console.log('[slide click] 向左移动到克隆位置，允许后续重置');
                this.index = clickedIndex;
              } else if (stepsToMove > 0) {
                // 向右移动：直接移动到被点击的位置（可能是克隆）
                console.log('[slide click] 向右移动到克隆位置，允许后续重置');
                this.index = clickedIndex;
              }
            } else {
              // 没找到对应的真实项，直接切换
              console.log('[slide click] 未找到真实项，直接切换');
              this.index = clickedIndex;
            }
        
            this.translateTo(this.index, true);
            this.updateProductCard();
            this.playCenterVideo();
            this.resetAutoplay();
          });
        });
      }

      // Product card items 点击切换到对应 slide
      if (this.productItems && this.productItems.length) {
        this.productItems.forEach((item) => {
          item.addEventListener('click', (e) => {
            // 如果点击的是加购按钮，不阻止事件，让加购功能正常工作
            const addToCartBtn = e.target.closest('.mt-add-to-cart, .mt-swiper-add-to-cart');
            if (addToCartBtn) {
              return; // 不阻止事件，让加购按钮的点击事件正常触发
            }
            // 如果点击的是产品标题链接，不拦截默认跳转
            const productLink = e.target.closest('.mt-swiper-product-title');
            if (productLink) {
              return;
            }
            e.preventDefault();
            const idxAttr = item.getAttribute('data-block-index');
            const realIdx = parseInt(idxAttr, 10);
            if (Number.isNaN(realIdx)) return;

            const allSlides = Array.from(this.wrapper.querySelectorAll('.mt-swiper-slide'));
            if (!allSlides.length) return;

            // 选择离当前中心最近的同 block-index slide，避免被首尾克隆劫持
            const matches = allSlides
              .map((slide, idx) => ({ slide, idx }))
              .filter(({ slide }) => String(slide.getAttribute('data-block-index')) === String(realIdx));
            if (!matches.length) return;

            const currentCenterIdx = this.index + this.centerOffset();
            const cloneCount = this.cloneCount ?? Math.max(this.visible, Math.min(this.realCount, 3));
            const rangeStart = cloneCount; // real slides 的最小 index
            const rangeEnd = cloneCount + this.realCount - 1; // real slides 的最大 index

            // 优先选择“不需要边界修正”的候选项，避免 transitionend 瞬跳导致左侧露空。
            const candidates = matches.map(({ idx }) => {
              const candidateIndex = idx - this.centerOffset();
              return { fullIdx: idx, candidateIndex };
            });
            const inRange = candidates.filter((c) => c.candidateIndex >= rangeStart && c.candidateIndex <= rangeEnd);
            const pickFrom = inRange.length ? inRange : candidates;

            let target = pickFrom[0];
            let bestDist = Math.abs(target.fullIdx - currentCenterIdx);
            for (let k = 1; k < pickFrom.length; k++) {
              const dist = Math.abs(pickFrom[k].fullIdx - currentCenterIdx);
              if (dist < bestDist) {
                bestDist = dist;
                target = pickFrom[k];
              }
            }

            const nextIndex = target.fullIdx - this.centerOffset();
            console.log('[product card click] realIdx:', realIdx, 'target.fullIdx:', target.fullIdx, 'nextIndex:', nextIndex, 'current index:', this.index);
            
            if (nextIndex === this.index) {
              // 当前已是目标项：仅更新卡片与自动播放，不重置视频进度
              console.log('[product card click] 已经是当前项，不做切换');
              this.updateProductCard();
              this.resetAutoplay();
              return;
            }

            // 如果目标索引在真实 slides 范围内，设置跳过边界检查标记
            if (nextIndex >= rangeStart && nextIndex <= rangeEnd) {
              console.log('[product card click] 目标在真实范围内 [', rangeStart, '-', rangeEnd, ']，设置 skipNextBoundaryCheck = true');
              this.skipNextBoundaryCheck = true;
            } else {
              console.log('[product card click] 目标在克隆范围内，不设置跳过标记');
            }

            this.index = nextIndex;
            this.translateTo(this.index, true);
            this.updateProductCard();
            this.playCenterVideo();
            this.resetAutoplay();
          });
        });
      }

      // Mouse events for dragging
      this.wrapper.addEventListener('mousedown', this.handleMouseDown.bind(this));
      document.addEventListener('mousemove', this.handleMouseMove.bind(this));
      document.addEventListener('mouseup', this.handleMouseUp.bind(this));

      // Touch events（touchmove 仅在判定为横向时 preventDefault，竖向滑动不拦截页面滚动）
      this.wrapper.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
      this.wrapper.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: false });
      this.wrapper.addEventListener('touchend', this.handleTouchEnd.bind(this));
      this.wrapper.addEventListener('touchcancel', this.handleTouchEnd.bind(this));

      // Pause autoplay on hover
      this.wrapper.addEventListener('mouseenter', () => this.stopAutoplay());
      this.wrapper.addEventListener('mouseleave', () => this.startAutoplay());

      // Resize
      window.addEventListener('resize', this.debounce(() => {
        requestAnimationFrame(() => {
          this.translateTo(this.index, false);
        });
      }, 100));
    }

    handleMouseDown(e) {
      if (this.isTransitioning || this.isDragging) return;
      this.isDragging = true;
      this.startX = e.clientX;
      this.wrapper.style.cursor = 'grabbing';
      this.wrapper.style.transition = 'none'; // 拖动时禁用过渡
      this.initialTransform = this.getCurrentTransform();
      this.stopAutoplay();
      e.preventDefault();
    }

    handleMouseMove(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      this.currentX = e.clientX;
      this.offsetX = this.currentX - this.startX;
      
      // 实时应用拖动偏移，保持精度
      const newX = this.initialTransform + this.offsetX;
      const newXInt = Math.round(newX);
      this.wrapper.style.transform = 'translate3d(' + newXInt + 'px, 0, 0)';
    }

    handleMouseUp(e) {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.wrapper.style.cursor = 'grab';
      this.wrapper.style.transition = 'transform 400ms ease'; // 恢复过渡

      const w = this.slideSize();
      if (w === 0) {
        // 如果宽度为0，延迟执行
        requestAnimationFrame(() => {
          this.handleMouseUp(e);
        });
        return;
      }

      const gap = this.getGap();
      const step = w + gap;
      const threshold = step * 0.1; // 拖动超过10%的距离才切换

      if (Math.abs(this.offsetX) > threshold && !this.isTransitioning) {
        // 拖动距离足够，切换到下一个/上一个
        if (this.offsetX > 0) {
          this.prev();
        } else {
          this.next();
        }
      } else {
        // 拖动距离不够，回到当前位置
        this.translateTo(this.index, true);
      }
      
      this.offsetX = 0;
      this.startAutoplay();
    }

    handleTouchStart(e) {
      if (this.isTransitioning) return;
      if (this.isDragging) return;
      this.touchSession = true;
      this.touchGesture = null;
      this.offsetX = 0;
      this.startX = e.touches[0].clientX;
      this.startY = e.touches[0].clientY;
      this.initialTransform = this.getCurrentTransform();
      this.stopAutoplay();
    }

    /**
     * 根据位移判定横向 / 竖向；仅横向时阻止默认行为并跟手拖动，竖向不拦截页面滚动。
     */
    handleTouchMove(e) {
      if (!this.touchSession) return;

      const touch = e.touches[0];
      const dx = touch.clientX - this.startX;
      const dy = touch.clientY - this.startY;
      const absDx = Math.abs(dx);
      const absDy = Math.abs(dy);

      if (this.touchGesture === null) {
        if (absDx < TOUCH_SLOP_PX && absDy < TOUCH_SLOP_PX) {
          return;
        }
        if (absDx >= absDy * TOUCH_HORIZONTAL_RATIO) {
          this.touchGesture = 'horizontal';
          this.isDragging = true;
          this.wrapper.style.transition = 'none';
        } else {
          this.touchGesture = 'vertical';
          this.offsetX = 0;
          return;
        }
      }

      if (this.touchGesture === 'vertical') {
        return;
      }

      e.preventDefault();
      this.currentX = touch.clientX;
      this.offsetX = dx;
      const newX = this.initialTransform + this.offsetX;
      const newXInt = Math.round(newX);
      this.wrapper.style.transform = 'translate3d(' + newXInt + 'px, 0, 0)';
    }

    handleTouchEnd(e) {
      if (!this.touchSession) return;

      if (this.touchGesture === 'vertical' || this.touchGesture === null) {
        this.touchSession = false;
        this.touchGesture = null;
        this.offsetX = 0;
        this.startAutoplay();
        return;
      }

      this.isDragging = false;
      this.wrapper.style.transition = 'transform 400ms ease';

      const w = this.slideSize();
      if (w === 0) {
        requestAnimationFrame(() => {
          this.handleTouchEnd(e);
        });
        return;
      }

      this.touchSession = false;
      this.touchGesture = null;

      const gap = this.getGap();
      const step = w + gap;
      const threshold = step * 0.1;

      if (Math.abs(this.offsetX) > threshold && !this.isTransitioning) {
        if (this.offsetX > 0) {
          this.prev();
        } else {
          this.next();
        }
      } else {
        this.translateTo(this.index, true);
      }

      this.offsetX = 0;
      this.startAutoplay();
    }

    prev() {
      // 清除当前居中 slide 的手动暂停标记
      const centerIdx = this.index + this.centerOffset();
      this.manuallyPausedVideos.delete(centerIdx);
      
      this.index -= 1;
      console.log('[prev] 向左切换，新 index:', this.index);
      this.translateTo(this.index, true);
      this.resetAutoplay();
    }

    next() {
      // 清除当前居中 slide 的手动暂停标记
      const centerIdx = this.index + this.centerOffset();
      this.manuallyPausedVideos.delete(centerIdx);
      
      this.index += 1;
      console.log('[next] 向右切换，新 index:', this.index);
      this.translateTo(this.index, true);
      this.resetAutoplay();
    }

  playCenterVideo() {
    const all = Array.from(this.wrapper.querySelectorAll('.mt-swiper-slide'));
    const cIdx = this.index + this.centerOffset();
    const centerNode = all[cIdx];
    if (!centerNode) return;

    // 处理所有视频：居中播放，其他暂停
    all.forEach((slide, index) => {
      const video = slide.querySelector('.mt-swiper-video');
      const poster = slide.querySelector('.mt-swiper-video-poster');
      const muteBtn = slide.querySelector('.mt-swiper-mute-btn');
      const playPauseBtn = slide.querySelector('.mt-swiper-play-pause-btn');
      
      if (video) {
        if (index === cIdx) {
          // 居中项：检查是否被用户手动暂停
          const isManuallyPaused = this.manuallyPausedVideos.has(index);
          console.log('[playCenterVideo] 居中项 index:', index, 'isManuallyPaused:', isManuallyPaused);
          
          if (muteBtn) {
            video.muted = muteBtn.classList.contains('mt-swiper-mute-btn--muted');
          }
          
          if (!isManuallyPaused) {
            // 只有未被手动暂停时才自动播放。
            // 若已在播放则不要 currentTime=0，避免 translateTo 后立即 play、transitionend 再进此函数时的二次 seek 卡顿。
            if (video.paused || video.ended) {
              video.currentTime = 0;
            }
            video.play().catch(() => {});
            if (poster) {
              poster.style.opacity = '0';
              poster.style.pointerEvents = 'none';
            }
            // 隐藏播放/暂停按钮
            if (playPauseBtn) {
              playPauseBtn.classList.remove('show');
              playPauseBtn.style.display = 'none';
            }
          } else {
            // 用户手动暂停的，保持暂停状态并显示播放按钮
            if (poster) {
              poster.style.opacity = '0';
              poster.style.pointerEvents = 'none';
            }
          }
        } else {
          // 其他视频：暂停并显示封面，清除手动暂停标记
          video.pause();
          video.currentTime = 0;
          this.manuallyPausedVideos.delete(index);
          
          video.muted = true;
          if (muteBtn) {
            muteBtn.classList.add('mt-swiper-mute-btn--muted');
          }
          if (poster) {
            poster.style.opacity = '1';
            poster.style.pointerEvents = 'auto';
          }
          // 隐藏播放/暂停按钮
          if (playPauseBtn) {
            playPauseBtn.classList.remove('show');
            playPauseBtn.style.display = 'none';
          }
        }
      }
    });
  }

    setupVideos() {
      const videos = this.section.querySelectorAll('.mt-swiper-video');
      videos.forEach((video) => {
        video.muted = true;
        // 初始状态：所有视频都暂停，显示封面
        video.pause();
        video.currentTime = 0;
      });
      
      // 初始显示所有封面
      const posters = this.section.querySelectorAll('.mt-swiper-video-poster');
      posters.forEach((poster) => {
        poster.style.opacity = '1';
        poster.style.pointerEvents = 'auto';
      });

      // 视频点击：只有居中的视频才能暂停/播放切换，其他视频点击时切换 slide
      videos.forEach((video) => {
        const slide = video.closest('.mt-swiper-slide');
        const playPauseBtn = slide.querySelector('.mt-swiper-play-pause-btn');
        const playIcon = slide.querySelector('.mt-swiper-play-icon');
        const pauseIcon = slide.querySelector('.mt-swiper-pause-icon');
        
        // 视频点击事件
        video.addEventListener('click', (e) => {
          // 获取当前 slide 的索引
          const allSlides = Array.from(this.wrapper.querySelectorAll('.mt-swiper-slide'));
          const slideIndex = allSlides.indexOf(slide);
          const centerIdx = this.index + this.centerOffset();
          
          console.log('[video click] slideIndex:', slideIndex, 'centerIdx:', centerIdx);
          
          // 只有居中的视频才处理播放/暂停，否则让事件冒泡到 slide 点击事件
          if (slideIndex !== centerIdx) {
            console.log('[video click] 非居中视频，让事件冒泡切换 slide');
            return; // 不阻止事件，让 slide 的点击事件处理切换
          }
          
          // 居中视频：阻止事件冒泡，处理播放/暂停
          e.stopPropagation();
          
          console.log('[video click] 居中视频，当前状态 paused:', video.paused);
          
          if (video.paused) {
            // 播放：移除手动暂停标记
            this.manuallyPausedVideos.delete(slideIndex);
            console.log('[video click] 移除手动暂停标记，开始播放');
            video.play().catch(() => {});
            if (playPauseBtn) {
              playPauseBtn.classList.remove('show');
              setTimeout(() => {
                if (!video.paused) {
                  playPauseBtn.style.display = 'none';
                }
              }, 300);
            }
          } else {
            // 暂停：添加手动暂停标记
            this.manuallyPausedVideos.add(slideIndex);
            console.log('[video click] 添加手动暂停标记，暂停播放');
            video.pause();
            if (playPauseBtn && playIcon && pauseIcon) {
              playIcon.style.display = 'block';
              pauseIcon.style.display = 'none';
              playPauseBtn.style.display = 'block';
              setTimeout(() => playPauseBtn.classList.add('show'), 10);
            }
          }
        });
      });

      // 播放/暂停按钮点击
      const playPauseBtns = this.section.querySelectorAll('.mt-swiper-play-pause-btn');
      playPauseBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const slide = btn.closest('.mt-swiper-slide');
          const video = slide.querySelector('.mt-swiper-video');
          const playIcon = btn.querySelector('.mt-swiper-play-icon');
          const pauseIcon = btn.querySelector('.mt-swiper-pause-icon');
          
          // 获取当前 slide 的索引
          const slideIndex = Array.from(this.wrapper.querySelectorAll('.mt-swiper-slide')).indexOf(slide);
          
          if (video) {
            console.log('[play-pause btn click] slideIndex:', slideIndex, '当前状态 paused:', video.paused);
            if (video.paused) {
              // 播放：移除手动暂停标记
              this.manuallyPausedVideos.delete(slideIndex);
              console.log('[play-pause btn click] 移除手动暂停标记');
              video.play().catch(() => {});
              btn.classList.remove('show');
              setTimeout(() => {
                btn.style.display = 'none';
              }, 300);
            } else {
              // 暂停：添加手动暂停标记
              this.manuallyPausedVideos.add(slideIndex);
              console.log('[play-pause btn click] 添加手动暂停标记');
              video.pause();
              btn.classList.add('show');
            }
          }
        });
      });

      // Mute button handlers
      const muteButtons = this.section.querySelectorAll('.mt-swiper-mute-btn');
      muteButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          console.log('[mt-swiper2] mute button clicked');
          const slide = btn.closest('.mt-swiper-slide');
          const video = slide.querySelector('.mt-swiper-video');
          if (video) {
            video.muted = !video.muted;
            btn.classList.toggle('mt-swiper-mute-btn--muted', video.muted);
          }
        });
      });
    }

    updateActiveSlide(cIdx) {
      // 更新所有 slides 的 active 状态
      const allSlides = Array.from(this.wrapper.querySelectorAll('.mt-swiper-slide'));
      allSlides.forEach((slide, index) => {
        slide.classList.remove('mt-swiper-slide--active');
        if (index === cIdx) {
          slide.classList.add('mt-swiper-slide--active');
        }
      });
    }

    updateProductCard() {
      const realIdx = this.indexToReal(this.index);
      // 先清除所有产品卡的 active 状态
      this.productItems.forEach((item) => {
        item.classList.remove('mt-swiper-product-item--active');
      });
      // 再根据真实 block 序号，从映射里找到对应的产品卡
      const activeItem = this.productMap.get(realIdx);
      if (activeItem) {
        activeItem.classList.add('mt-swiper-product-item--active');
      }
    }

    startAutoplay() {
      if (this.autoplayDelay <= 0) return;
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => {
        this.next();
      }, this.autoplayDelay * 1000);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    resetAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    getCurrentTransform() {
      const transform = this.wrapper.style.transform;
      if (!transform || transform === 'none') {
        // 如果没有内联样式，尝试从计算样式获取（更准确）
        const computedStyle = window.getComputedStyle(this.wrapper);
        const matrix = computedStyle.transform;
        if (matrix && matrix !== 'none') {
          const values = matrix.split('(')[1].split(')')[0].split(',');
          return parseFloat(values[4]) || 0;
        }
        return 0;
      }
      const match = transform.match(/translate3d\(([^,]+)/);
      return match ? parseFloat(match[1]) : 0;
    }

    debounce(fn, wait) {
      let t;
      return function() {
        clearTimeout(t);
        t = setTimeout(fn, wait);
      };
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMtSwiper);
  } else {
    initMtSwiper();
  }

  // Reinitialize on section load (for Shopify theme editor)
  if (typeof document.addEventListener !== 'undefined') {
    document.addEventListener('shopify:section:load', function (event) {
      if (event.detail.sectionId) {
        const section = document.querySelector(`.section-${event.detail.sectionId}`);
        if (section && section.classList.contains('mt-swiper-section')) {
          new MtSwiper(section);
        }
      }
    });
  }
})();

